import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from './ErrorPage';

export const NotFoundPage: FunctionComponent<{ desc?: string }> = ({ desc }) => {
    const { t } = useTranslation();

    return (
        <ErrorPage
            code={404}
            title={t('error.pageNotFound.title')}
            message={t('error.pageNotFound.message')}
            desc={desc}
        />
    );
};
